import React, { ReactNode } from "react";
import styled from "styled-components";

import Navigation from "./navigation/Navigation";
import PageHeader from "./pageHeader/PageHeader";

const PageWrapper = ({ children }: { children?: ReactNode }) => (
  <Wrap>
    <Navigation />
    <Content>
      <PageHeader />
      <Inner>{children}</Inner>
    </Content>
  </Wrap>
);

export default PageWrapper;

const Wrap = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.bg.basis};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const Inner = styled.main`
  /* Sticky footers (FormFooter) pin to this scrollport's content box, i.e.
     above the bottom padding, so they need to know it to bleed over it. */
  --page-gutter-bottom: 1.5rem;

  flex: 1;
  overflow: auto;
  padding: 0 1.5rem var(--page-gutter-bottom);
  display: flex;
  flex-direction: column;

  /* A page that is a single card fills the scrollport, so a short form still
     puts its footer on the bottom edge instead of halfway up the screen. It grows
     past it when the content is taller (flex-shrink: 0, auto basis): a form card
     has no inner scroller, so a card clamped to the scrollport would end its
     background — and its footer shadow — mid-form, leaving the fields below it on
     the bare page. */
  > :only-child {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }

  /* Grids and charts scroll their own rows instead: they take exactly the
     scrollport height and hand it down, so the page itself never scrolls. */
  > :only-child[data-page-scroll="inner"] {
    flex: 1 1 0;
    min-height: 0;
  }
`;
